import API from "./API";
import axios from "axios";

export const CRM = {

    async getEnrollment(id){
        const url = API.url(`/crm/enrollments/${id}`);
        return await axios.get(url);
    },

    async downloadEnrollmentDoc(id, name){
        const url = API.url(`/study/enrollments/${id}/${name}/doc.pdf`);
        return await API.downloadFile(url, name + '.pdf');
    },

    async getUsers(){
        const url = API.url(`/crm/users`);
        return await axios.get(url);
    },

    async getUser(idOrEmail){
        const url = API.url(`/crm/users/${idOrEmail}`);
        return await axios.get(url);
    },

    async notHot(id){
        const url = API.url(`/crm/users/${id}/not-hot`);
        return await axios.put(url);
    },

    async getPersons(search, page){
        const url = API.url(`/crm/users?search=${search}&page=${page}`);
        return await axios.get(url);
    },

    async getPerson(id){
        const url = API.url(`/crm/users/${id}`);
        return await axios.get(url);
    },

    async postPerson(data){
        const url = API.url(`/crm/users`);
        return await axios.post(url, data);
    },

    async putPerson(id, data){
        const url = API.url(`/crm/users/${id}`);
        return await axios.put(url, data);
    },

    async getPersonEnrollments(personId){
        const url = API.url(`/crm/users/${personId}/enrollments`);
        return await axios.get(url);
    },

    async postEnrollment(data){
        const url = API.url(`/crm/enrollments`);
        return await axios.post(url, data);
    },

    async putEnrollment(data){
        const url = API.url(`/crm/enrollments/${data.id}`);
        return await axios.put(url, data);
    },

    async deleteEnrollment(id){
        const url = API.url(`/crm/enrollments/${id}`);
        return await axios.delete(url);
    },

    async completeEnrollment(id){
        const url = API.url(`/crm/enrollments/${id}/complete`);
        return await axios.put(url, null);
    }, 

    async payEnrollment(id){
        const url = API.url(`/crm/enrollments/${id}/paid`);
        return await axios.put(url, null);
    }, 

    async changeEnrollmentOwner(id, email){
        const url = API.url(`/crm/enrollments/${id}/user/change`);
        const data = {email: email};
        return await axios.put(url, data);
    }, 

    async getPersonActivities(personId){
        const url = API.url(`/crm/users/${personId}/activities`);
        return await axios.get(url);
    },

    async getPersonCalls(personId){
        const url = API.url(`/crm/users/${personId}/calls`);
        return await axios.get(url);
    },

    async postActivity(data){
        const url = API.url(`/crm/activities`);
        return await axios.post(url, data);
    },

    async deleteActivity(id){
        const url = API.url(`/crm/activities/${id}`);
        return await axios.delete(url);
    },

    async getEnrollments(year){
        const url = API.url(`/crm/enrollments?year=${year}`);
        return await axios.get(url);
    },

    async getTeacherCourses(id){
        const url = API.url(`/crm/teachers/${id}/courses`);
        return await axios.get(url);
    },

    async postTeacherCourses(id, courses){
        const url = API.url(`/crm/teachers/${id}/courses`);
        return await axios.post(url, courses);
    },

    async getMyActivities(){
        const url = API.url(`/crm/activities`);
        return await axios.get(url);
    },

    async getActivityEvents(){
        const url = API.url(`/crm/activities/events`);
        return await axios.get(url);
    },

    async getProspects(){
        const url = API.url(`/crm/prospects`);
        return await axios.get(url);
    },

    async getProspect(id){
        const url = API.url(`/crm/prospects/${id}`);
        return await axios.get(url);
    },

    async putProspect(data){
        const url = API.url(`/crm/prospects/${data.id}`);
        return await axios.put(url, data);
    },

    async deleteProspect(id){
        const url = API.url(`/crm/prospects/${id}`);
        return await axios.delete(url);
    },

    async postProspect(data){
        const url = API.url(`/crm/prospects`);
        return await axios.post(url, data);
    },

    async getGroups(){
        const url = API.url(`/crm/groups`);
        return await axios.get(url);
    },

    async getGroup(id){
        const url = API.url(`/crm/groups/${id}`);
        return await axios.get(url);
    },

    async postGroup(data){
        const url = API.url(`/crm/groups`);
        return await axios.post(url, data);
    },

    async putGroup(data){
        const url = API.url(`/crm/groups/${data.id}`);
        return await axios.put(url, data);
    },
    
    async deleteGroup(id){
        const url = API.url(`/crm/groups/${id}`);
        return await axios.delete(url);
    },

    async getFirms(){
        const url = API.url(`/crm/firms`);
        return await axios.get(url);
    },

    async getFirm(id){
        const url = API.url(`/crm/firms/${id}`);
        return await axios.get(url);
    },

    async postFirm(data){
        const url = API.url(`/crm/firms`);
        return await axios.post(url, data);
    },

    async putFirm(data){
        const url = API.url(`/crm/firms/${data.id}`);
        return await axios.put(url, data);
    },
    
    async deleteFirm(id){
        const url = API.url(`/crm/firms/${id}`);
        return await axios.delete(url);
    },

    async getStats(start, end){
        const url = API.url(`/crm/stats?start=${start}&end=${end}`);
        console.log(url);
        return await axios.get(url);
    },

    async getAdmins(){
        const url = API.url(`/crm/admins`);
        return await axios.get(url);
    },

    async getEventActivities(){
        const url = API.url(`/crm/event-activities`);
        return await axios.get(url);
    },

    async hot(type){
        const url = API.url(`/crm/hot/${type}`);
        return await axios.put(url);
    },

}

export default CRM;
